import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/my-resumes',
    name: 'resumes',
    component: () => import('@/modules/Resume/pages/ResumesView.vue'),
    meta: {
      title: "Mening rezyumelarim — cvLab",
      description: "Saqlangan CV laringizni ko'rib chiqing va tahrirlang.",
    },
  },
  {
    path: '/r/:slug',
    name: 'public-resume',
    component: () => import('@/modules/Resume/pages/PublicResumeView.vue'),
    meta: {
      title: "CV Ko'rish — cvLab",
    },
  },
]

export default routes
